import { useRef } from 'react';

/**
 * Returns the result of the function passed as parameter.
 * The function is called just once and therefore the returned value is stable
 * and don't change in every render.
 * @template T
 * @param {() => T} initializer
 * @returns {T}
 */
function useInitializer(initializer) {
  /** @type {import('react').MutableRefObject<T>} */
  var ref = useRef();
  if (!ref.current) {
    ref.current = initializer();
  }
  return ref.current;
}

export { useInitializer };
//# sourceMappingURL=useInitializer.js.map
